import React from "react";
import { Form } from "react-bootstrap";
import { UpdateElectricityAgreementRenewalPlanModalForm } from "../modals/UpdateElectricityAgreementRenewalPlanModal";
import { onNumberChange } from "helpers";

interface UpdateElectricityAgreementRenewalPlanProductionPriceFormProps {
    form: UpdateElectricityAgreementRenewalPlanModalForm;
    setForm: (form: UpdateElectricityAgreementRenewalPlanModalForm) => void;
}

export default function UpdateElectricityAgreementRenewalPlanProductionPriceForm(
    { form, setForm } : UpdateElectricityAgreementRenewalPlanProductionPriceFormProps
) {
    
    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Label>Tootmise marginaal KM-ta (s/kWh)*</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        value={form.productionMarginal}
                        step={0.001}
                        onChange={(e: any) => setForm({
                            ...form,
                            productionMarginal: onNumberChange(e)
                        })}
                        onWheel={(e: any) => e.target.blur()}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
            </div>
        </>
    );
}